// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"letters-h"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M8 5V12M8 12H16M8 12V19M16 12V5M16 12V19","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const LettersHIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'letters-h',
    ref,
    icon: element,
  },
));

LettersHIcon.displayName = 'LettersHIcon';

export default LettersHIcon;
